import { render, staticRenderFns } from "./basicInformation.vue?vue&type=template&id=135e0018&scoped=true&"
import script from "./basicInformation.vue?vue&type=script&lang=js&"
export * from "./basicInformation.vue?vue&type=script&lang=js&"
import style0 from "./basicInformation.vue?vue&type=style&index=0&id=135e0018&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135e0018",
  null
  
)

export default component.exports